
import * as am4core from "@amcharts/amcharts4/core";
let moment = require('moment');

export default {
    namespaced: true,

    state: {
        totalRecipeSize: null,                //referring to the measured size input by the user
        recipeSizeUnits: null,                //referring to the measured size unit input by the user
        showAllShoppingList: false,
        categoryOptions: ['Meat','Produce','Canned Goods','Personal'],  //when adding an item to the shopping list
        unitOptions: ['Count','Cup','Oz','lb'],                         //when adding an item to the shopping list
        // totalCalories: 4000,
        savedMenu: false,
        weekStart: moment().startOf('week'),
        weekEnd: moment().endOf('week'),
        weekOffset: 0,
        today: Number(moment().format('e')),
        day: Number(moment().format('e')),  //was Number(moment().format('e')) to default to today
        mealSplitChartData: [
            {
              meal: "Eat Now",
              calories: 2400,
              percent: 62,
              color: am4core.color("#66BB6A")
            },
            {
              meal: "Save",
              calories: 1500,
              percent: 38,
              color: am4core.color("#E0E0E0")
            },
        ],
        shoppingList: [
            {
              category: 'Produce',
              items: [
                {
                  name: 'celery',
                  quantity: 3,
                  units: 'count',
                  purchased: false,
                },
                {
                  name: 'apple',
                  quantity: 6,
                  units: 'count',
                  purchased: false,
                },
                {
                  name: 'strawberries',
                  quantity: 1,
                  units: 'lb',
                  purchased: false,
                }
              ]
            },
            {
              category: 'Canned Goods',
              items: [
                {
                  name: 'whole-kernel corn',
                  quantity: 1,
                  units: '14.5 oz can',
                  purchased: false,
                },
                {
                  name: 'peas',
                  quantity: 2,
                  units: '14.5 oz can',
                  purchased: false,
                },
                {
                  name: 'chicken broth',
                  quantity: 2,
                  units: '32oz box',
                  purchased: false,
                },
                {
                  name: 'tomato paste',
                  quantity: 1,
                  units: '6oz can',
                  purchased: false,
                }
              ]
            },
            {
              category: 'Meat',
              items: [
                {
                  name: 'chicken breast',
                  quantity: 24,
                  units: 'oz',
                  purchased: false,
                },
                {
                  name: 'ground beef',
                  quantity: 1,
                  units: 'lb',
                  purchased: false,
                },
              ]
            },
        ],    
        persons: [
            {
            "name": "Dad",
            "calories": 3200,
            "percent": 35,
            },
            {
            "name": "Erich",
            "calories": 3000,
            "percent": 33,
            },
            {
            "name": "Mom",
            "calories": 1600,
            "percent": 17,
            },
            {
            "name": "Lily",
            "calories": 1400,
            "percent": 15,
            },
        ],
        // nutrition: [
        //     {
        //       category: 'Total Fat',
        //       amount: 8,
        //       unit: 'g',
        //       ml: 'ml-0',
        //       fontWeight: 'font-weight-bold'
        //     },
        //     {
        //       category: 'Saturated Fat',
        //       amount: 4,
        //       unit: 'g',
        //       ml: 'ml-4',
        //       fontWeight: 'font-weight-regular'
        //     },
        //     {
        //       category: 'Trans Fat',
        //       amount: 0,
        //       unit: 'g',
        //       ml: 'ml-4',
        //       fontWeight: 'font-weight-regular'
        //     },
        //     {
        //       category: 'Cholesterol',
        //       amount: 0,
        //       unit: 'mg',
        //       ml: 'ml-0',
        //       fontWeight: 'font-weight-bold'
        //     },
        //     {
        //       category: 'Sodium',
        //       amount: 160,
        //       unit: 'mg',
        //       ml: 'ml-0',
        //       fontWeight: 'font-weight-bold'
        //     },
        //     {
        //       category: 'Total Carbohydrate',
        //       amount: 20,
        //       unit: 'g',
        //       ml: 'ml-0',
        //       fontWeight: 'font-weight-bold'
        //     },
        //     {
        //       category: 'Dietary Fiber',
        //       amount: 2,
        //       unit: 'g',
        //       ml: 'ml-4',
        //       fontWeight: 'font-weight-regular'
        //     },
        //     {
        //       category: 'Sugars',
        //       amount: 1,
        //       unit: 'g',
        //       ml: 'ml-4',
        //       fontWeight: 'font-weight-regular'
        //     },
        //     {
        //       category: 'Protein',
        //       amount: 8,
        //       unit: 'g',
        //       ml: 'ml-0',
        //       fontWeight: 'font-weight-bold'
        //     },
        // ],
        ingredients: [
            {
              name: 'quorn mince',
              amount: '300',
              unit: 'g',
              prep: ''
            },
            {
              name: 'vegetable oil',
              amount: '2',
              unit: 'T',
              prep: ''
            },
            {
              name: 'onion',
              amount: '1',
              unit: '',
              prep: 'finely diced'
            },
            {
              name: 'garlic clove',
              amount: '2',
              unit: '',
              prep: 'finely chopped'
            },
            {
              name: 'chilli puree',
              amount: '2',
              unit: 'tsp',
              prep: ''
            },
            {
              name: 'smoked paprika',
              amount: '1',
              unit: 'tsp',
              prep: ''
            },
            {
              name: 'kidney beans in chili sauce',
              amount: '1',
              unit: 'can',
              prep: ''
            },
            {
              name: 'tomato puree',
              amount: '3',
              unit: 'T',
              prep: ''
            },
            {
              name: 'vegetable stock',
              amount: '200',
              unit: 'ml',
              prep: ''
            },
            {
              name: 'salt and freshly ground black pepper to taste',
              amount: '',
              unit: '',
              prep: ''
            },
            {
              name: 'coriander',
              amount: '1',
              unit: 'T',
              prep: 'finely chopped'
            },
        ],
        directions: [
            {
              number: '1',
              directions: 'Heat the oil in a large frying pan, over a medium high heat. Cook the onion for 3 minutes. Add the garlic, chili puree and smoked paprika and cook for an additional 2 minutes'
            },
            {
              number: '2',
              directions: 'Add the kidney beans, tomato puree, vegetable stock and Quorn Mince. Simmer for 10 minutes, stirring occasionally.'
            },
            {
              number: '3',
              directions: 'Season to taste and stir in the fresh coriander.'
            },
        ],
        menu: [
            {
            day: 'Sunday',
            details: [
              {
                mealType: 'Breakfast',
                mealImage: require('@/assets/sausageAndEggs.png'),
                mealName: 'Sausage & Eggs',
                mealId: '1',
              },
              {
                mealType: 'Snack',
                mealImage: require('@/assets/snack.png'),
                mealName: 'Morning Snack',
                mealId: '2',
              },
              {
                mealType: 'Lunch',
                mealImage: require('@/assets/chickenSalad.png'),
                mealName: 'Chicken Salad',
                mealId: '3',
              },
              {
                mealType: 'Snack',
                mealImage: require('@/assets/snack.png'),
                mealName: 'Afternoon Snack',
                mealId: '4',
              },
              {
                mealType: 'Dinner',
                mealImage: require('@/assets/homestyleChicken.png'),
                mealName: 'Homestyle Chicken',
                mealId: '5',
              },
              {
                mealType: 'Snack',
                mealImage: require('@/assets/snack.png'),
                mealName: 'Evening Snack',
                mealId: '6',
              }
            ]
            },
            {
            day: 'Monday',
            details: [
              {
                mealType: 'Breakfast',
                mealImage: require('@/assets/granola.png'),
                mealName: 'Granola',
                mealId: '1',
              },
              {
                mealType: 'Snack',
                mealImage: require('@/assets/snack.png'),
                mealName: 'Morning Snack',
                mealId: '2',
              },
              {
                mealType: 'Lunch',
                mealImage: require('@/assets/leftovers.png'),
                mealName: 'Leftovers',
                mealId: '3',
              },
              {
                mealType: 'Snack',
                mealImage: require('@/assets/snack.png'),
                mealName: 'Afternoon Snack',
                mealId: '4',
              },
              {
              mealType: 'Dinner',
              mealImage: require('@/assets/beefTacos.png'),
              mealName: 'Beef Tacos',
              mealId: '5',
              },
              {
                mealType: 'Snack',
                mealImage: require('@/assets/snack.png'),
                mealName: 'Evening Snack',
                mealId: '6',
              }
            ]
            },
            {
            day: 'Tuesday',
            details: [
              {
                mealType: 'Breakfast',
                mealImage: require('@/assets/cheerios.png'),
                mealName: 'Cheerios',
                mealId: '1',
              },
              {
                mealType: 'Snack',
                mealImage: require('@/assets/snack.png'),
                mealName: 'Morning Snack',
                mealId: '2',
              },
              {
                mealType: 'Lunch',
                mealImage: require('@/assets/chickenSalad.png'),
                mealName: 'Chicken Salad',
                mealId: '3',
              },
              {
                mealType: 'Snack',
                mealImage: require('@/assets/snack.png'),
                mealName: 'Afternoon Snack',
                mealId: '4',
              },
              {
                mealType: 'Dinner',
                mealImage: require('@/assets/homestyleChicken.png'),
                mealName: 'Homestyle Chicken',
                mealId: '5',
              },
              {
                mealType: 'Snack',
                mealImage: require('@/assets/snack.png'),
                mealName: 'Evening Snack',
                mealId: '6',
              }
            ]
            },
            {
            day: 'Wednesday',
            details: [
              {
                mealType: 'Breakfast',
                mealImage: require('@/assets/granola.png'),
                mealName: 'Granola',
                mealId: '1',
              },
              {
                mealType: 'Snack',
                mealImage: require('@/assets/snack.png'),
                mealName: 'Morning Snack',
                mealId: '2',
              },
              {
                mealType: 'Lunch',
                mealImage: require('@/assets/leftovers.png'),
                mealName: 'Leftovers',
                mealId: '3',
              },
              {
                mealType: 'Snack',
                mealImage: require('@/assets/snack.png'),
                mealName: 'Afternoon Snack',
                mealId: '4',
              },
              {
                mealType: 'Dinner',
                mealImage: require('@/assets/beefTacos.png'),
                mealName: 'Beef Tacos',
                mealId: '5',
              },
              {
                mealType: 'Snack',
                mealImage: require('@/assets/snack.png'),
                mealName: 'Evening Snack',
                mealId: '6',
              }
            ]
            },
            {
            day: 'Thursday',
            details: [
              {
                mealType: 'Breakfast',
                mealImage: require('@/assets/sausageAndEggs.png'),
                mealName: 'Sausage & Eggs',
                mealId: '1',
              },
              {
                mealType: 'Snack',
                mealImage: require('@/assets/snack.png'),
                mealName: 'Morning Snack',
                mealId: '2',
              },
              {
                mealType: 'Lunch',
                mealImage: require('@/assets/chickenSalad.png'),
                mealName: 'Chicken Salad',
                mealId: '3',
              },
              {
                mealType: 'Snack',
                mealImage: require('@/assets/snack.png'),
                mealName: 'Afternoon Snack',
                mealId: '4',
              },
              {
                mealType: 'Dinner',
                mealImage: require('@/assets/homestyleChicken.png'),
                mealName: 'Homestyle Chicken',
                mealId: '5',
              },
              {
                mealType: 'Snack',
                mealImage: require('@/assets/snack.png'),
                mealName: 'Evening Snack',
                mealId: '6',
              }
            ]
            },
            {
            day: 'Friday',
            details: [
              {
                mealType: 'Breakfast',
                mealImage: require('@/assets/granola.png'),
                mealName: 'Granola',
                mealId: '1',
              },
              {
                mealType: 'Snack',
                mealImage: require('@/assets/snack.png'),
                mealName: 'Morning Snack',
                mealId: '2',
              },
              {
                mealType: 'Lunch',
                mealImage: require('@/assets/leftovers.png'),
                mealName: 'Leftovers',
                mealId: '3',
              },
              {
                mealType: 'Snack',
                mealImage: require('@/assets/snack.png'),
                mealName: 'Afternoon Snack',
                mealId: '4',
              },
              {
                mealType: 'Dinner',
                mealImage: require('@/assets/beefTacos.png'),
                mealName: 'Beef Tacos',
                mealId: '5',
              },
              {
                mealType: 'Snack',
                mealImage: require('@/assets/snack.png'),
                mealName: 'Evening Snack',
                mealId: '6',
              }
            ]
            },
            {
            day: 'Saturday',
            details: [
              {
                mealType: 'Breakfast',
                mealImage: require('@/assets/waffles.png'),
                mealName: 'Waffles',
                mealId: '1',
              },
              {
                mealType: 'Snack',
                mealImage: require('@/assets/snack.png'),
                mealName: 'Morning Snack',
                mealId: '2',
              },
              {
                mealType: 'Lunch',
                mealImage: require('@/assets/turkeySandwich.png'),
                mealName: 'Turkey Sandwich',
                mealId: '3',
              },
              {
                mealType: 'Snack',
                mealImage: require('@/assets/snack.png'),
                mealName: 'Afternoon Snack',
                mealId: '4',
              },
              {
                mealType: 'Dinner',
                mealImage: require('@/assets/eatOut.png'),
                mealName: 'Eat Out',
                mealId: '5',
              },
              {
                mealType: 'Snack',
                mealImage: require('@/assets/snack.png'),
                mealName: 'Evening Snack',
                mealId: '6',
              }
            ]
            },
          ],
    },

    actions: {
        updateRecipeSizeUnits({commit}, value) {
            commit('updateRecipeSizeUnits', value)
        },
        updateRecipeSize({commit}, value) {
            commit('updateRecipeSize', value)
        },
        savedMenu({commit}) {
            commit('savedMenu')
        },
        addWeek({commit}) {
            commit('addWeek')
        },
        subtractWeek({commit}) {
            commit('subtractWeek')
        },
        resetWeekOffset({commit}) {
            commit('resetWeekOffset')
        },
        updateDay({commit}) {
            commit('updateDay')
        },
        shoppingCheckBox({commit}, value) {
            commit('shoppingcheckBox', value)
        },
        showAllShoppingList({commit}) {
            commit('showAllShoppingList')
        },
        addCategory({commit}, value) {
            commit('addCategory',value)
        },
        addItem({commit},value) {
            commit('addItem',value)
        },
    },

    mutations: {
        updateRecipeSizeUnits(state, value) {
            state.recipeSizeUnits = value
        },
        updateRecipeSize(state, value) {
            state.totalRecipeSize = value
        },
        savedMenu(state){
            state.savedMenu = !state.savedMenu;
        },
        addWeek(state){
            state.weekOffset += 1;
            state.weekStart = moment().startOf('week').add(state.weekOffset,'week');
            state.weekEnd = moment().endOf('week').add(state.weekOffset,'week');
        },
        subtractWeek(state){
            state.weekOffset -= 1;
            state.weekStart = moment().startOf('week').add(state.weekOffset,'week');
            state.weekEnd = moment().endOf('week').add(state.weekOffset,'week');
        },
        resetWeekOffset(state){
            state.weekOffset = 0;
            state.weekStart = moment().startOf('week').add(state.weekOffset,'week');
            state.weekEnd = moment().endOf('week').add(state.weekOffset,'week');
            state.day = state.today
        },
        updateDay(state, value) {
            state.day = value;
        },
        shoppingcheckBox(state, value) {
            state.shoppingList[value[0]].items[value[1]].purchased = !state.shoppingList[value[0]].items[value[1]].purchased;
        },
        showAllShoppingList(state) {
            state.showAllShoppingList = !state.showAllShoppingList;
        },
        addCategory(state, value) {
            state.shoppingList.push(
            {
                "category": value,
                "items": []
            }
        )
        },
        addItem(state, value) {
            state.shoppingList[value[0]].items.push(value[1])
        },

    },

    getters: {
        recipeSize(state){
            return state.totalRecipeSize
        },
        recipeSizeUnits(state) {
            return state.recipeSizeUnits
        },
        persons(state) {
            return state.persons
        },
        unitOptions(state) {
            return state.unitOptions
        },
        savedMenu(state) {
            return state.savedMenu
        },
        weekStart(state) {
            return state.weekStart
        },
        weekEnd(state) {
            return state.weekEnd
        },
        weekOffset(state) {
            return state.weekOffset
        },
        today(state) {
            return state.today
        },
        menu(state) {
            return state.menu
        },
        day(state) {
            return state.day
        },
        mealSplitChartData(state) {
            return state.mealSplitChartData
        },
        // totalCalories(state) {
        //     return state.totalCalories
        // },
        // nutrition(state) {
        //     return state.nutrition
        // },
        ingredients(state) {
            return state.ingredients
          },
        directions(state) {
            return state.directions
        },
        shoppingList(state) {
            return state.shoppingList
        },
        showAllShoppingList(state) {
            return state.showAllShoppingList
        },
        categoryOptions(state) {
            return state.categoryOptions
        },
    }

}
